<template>
  <div class="app-container">
    <el-skeleton style="width: 240px" :loading="loading" animated>
      <template #default>
        <el-card
          :body-style="{ padding: '0px', marginBottom: '1px' }"
          v-for="item in lists"
          :key="item.name"
          style="box-shadow:rgb(219 211 211 / 58%) 8px 8px 14px 0px;margin:30px auto;width:90%;height:100px;border-radius: 22px;background-color:rgb(241,249, 253);"
        >
          <div style="padding: 9px;">
            <span style="font-size:27px;font-weight:600;color:#39b0d2;margin-left:15px">{{ item.name }}</span>
            <div class="bottom card-header">
              <span :class="produceStatus == 0 ? 'spanItemqq':'spanItem'" v-if="item.name == '生产核算方法'">{{statusFilter(produceStatus)}}</span>
              <span :class="tradeStatus == 0 ? 'spanItemqq':'spanItem'" v-if="item.name == '贸易核算方法'">{{statusFilter(tradeStatus)}}</span>
              <span :class="processStatus == 0 ? 'spanItemqq':'spanItem'" v-if="item.name == '委托核算方法'">{{statusFilter(processStatus)}}</span>
              <span :class="projectStatus == 0 ? 'spanItemqq':'spanItem'" v-if="item.name == '工程核算方法'">{{statusFilter(projectStatus)}}</span>
              <span :class="fwStatus == 0 ? 'spanItemqq':'spanItem'" v-if="item.name == '服务核算方法'">{{statusFilter(fwStatus)}}</span>
              <qzf-button v-if="item.name == '生产核算方法'" @success="goProduce">点击进入核算</qzf-button>
              <qzf-button v-if="item.name == '贸易核算方法'" @success="goTrade">点击进入核算</qzf-button>
              <qzf-button v-if="item.name == '委托核算方法'" @success="goProcess">点击进入核算</qzf-button>
              <qzf-button v-if="item.name == '工程核算方法'" @success="goProject">点击进入核算</qzf-button>
              <qzf-button v-if="item.name == '服务核算方法'" @success="goFw">点击进入核算</qzf-button>
            </div>
          </div>
        </el-card>
      </template>
    </el-skeleton>
  </div>
</template>




<script>
import { inventoryCheckStatus } from '@/api/inventory'
import costSetting from "./costSetting.vue"
export default {
  components: {
    costSetting,
  },
  props: {

  },
  data () {
    return {
      lists: [],
      loading: true,
      fwStatus:0,         //服务
      processStatus:0,    //委托核算
      produceStatus:0,    //生产核算
      projectStatus:0,    //工程核算
      tradeStatus:0       //贸易核算
    }
  },
  mounted() {
    this.loading = false
    this.lists = [
      {
        name: '生产核算方法',
      },
      {
        name: '贸易核算方法',
      },
      {
        name: '委托核算方法',
      },
      {
        name: '工程核算方法',
      },
      {
        name: '服务核算方法',
      },
    ]
  },
  created() {
    this.init()
    this.$bus.on("inventoryCheckUpdate", (val) => {
      this.init()
    });
  },
  methods: {
    goProduce(){
      this.$router.push({
        path: "/input/produceConvert",
        name: "produceConvert"
      });
    },
    goProject(){
      this.$router.push({
        path: "/input/projectConvert",
        name: "projectConvert"
      });
    },
    
    goTrade(){
      this.$router.push({
        path: "/input/tradeConvert",
        name: "tradeConvert"
      });
    },
    goProcess(){
      this.$router.push({
        path: "/input/processConvert",
        name: "processConvert"
      });
    },
    goFw(){
      this.$router.push({
        path: "/input/fwConvert",
        name: "fwConvert"
      });
    },
    init(){
      inventoryCheckStatus({}).then(res=>{
        console.log(res.data.data);
        this.processStatus = res.data.data.process
        this.produceStatus = res.data.data.produce
        this.projectStatus = res.data.data.project
        this.tradeStatus = res.data.data.trade
        this.fwStatus = res.data.data.fw
      })
    },
    statusFilter(status){
      if(status == 0){
        return "未开始"
      }else if(status == 1){
        return "已完成"+status+'次'
      }
    },
    
  }
}
</script>
<style scoped lang="scss">
ul {
  li {
    width: calc(100% - 20px);
    height: 80px;
    border: 1px solid #efefef;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 10px;
  }
}
.bottom{
  .spanItem{
    border-radius: 20px;
    background-color: #48D1CC;
    color: white;
    font-size: 17px;
    font-weight: 400;
    margin-top: 36px;
    padding: 3px 19px;
    margin-left: 10px;
  }
  .spanItemqq{
    border-radius: 20px;
    background-color: #DCDCDC;
    color: white;
    font-size: 17px;
    font-weight: 400;
    margin-top: 36px;
    padding: 3px 19px;
    margin-left: 10px;
  }
}
</style>